/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon20Solid = forwardRef('CheckCircleCutIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 18a8 8 0 0 0 7.304-11.27l-5.802 5.803a2.612 2.612 0 0 1-3.695 0l-2.489-2.49A1.05 1.05 0 1 1 6.803 8.56l2.489 2.489c.2.2.524.2.725 0L16.164 4.9A8 8 0 1 0 10 18Z" })));
});
